<script setup lang="ts">
import { computed, ref } from "vue";

import useTranslation from "@Composables/useTranslation";

//
// Setup
const { __ } = useTranslation();

//
// Props
interface Props {
  errors?: Record<string, string>;
  loading?: boolean;
  submit: (code: string) => void;
}

const props = withDefaults(defineProps<Props>(), {
  errors: () => ({}),
  loading: false,
});

//
// Data
const localCode = ref<string>("");

//
// Computed
const codeError = computed<string>(() => props.errors?.coupon ?? "");

//
// Exposed Test Vars
defineExpose({ localCode, codeError });
</script>

<template>
  <form
    class="billing-coupon"
    @submit.prevent="submit(localCode)"
  >
    <div class="alert alert-info billing-coupon__description">
      {{ __("settings_billing_page.coupon.description") }}
    </div>

    <div class="form-group">
      <label
        class="billing-coupon__label"
        for="billing-coupon-code"
      >
        {{ __("settings_billing_page.coupon.label") }}
      </label>
      <input
        id="billing-coupon-code"
        v-model="localCode"
        type="text"
        name="coupon"
        class="form-control billing-coupon__code _coupon"
        :class="{ 'is-invalid': codeError !== '' }"
      >
      <span
        v-if="codeError !== ''"
        class="invalid-feedback billing-coupon__error _coupon_error"
        role="alert"
      >
        {{ codeError }}
      </span>
    </div>

    <div class="form-group text-right mb-0">
      <button
        type="submit"
        class="btn btn-teal billing-coupon__submit _redeem"
        :disabled="loading"
      >
        {{ __("settings_billing_page.coupon.redeem") }}
        <i
          v-if="loading"
          class="fa fa-spin fa-spinner ml-1"
        />
      </button>
    </div>
  </form>
</template>

<style lang="scss" scoped>
.billing-coupon {
  &__error {
    display: block;
  }
}
</style>
